import { forwardRef, type HTMLAttributes } from 'react';
import clsx from 'clsx';

import styles from './googleFontIcon.module.scss';

type GoogleFontIconProps = {
  className?: string;
  name: string;
  title?: string;
  small?: boolean;
  solid?: boolean;
  'data-testid'?: string;
} & HTMLAttributes<HTMLSpanElement>;

const GoogleFontIcon = forwardRef<HTMLSpanElement, GoogleFontIconProps>(
  function GoogleFontIcon(
    { className, name, title, small, solid, ...props },
    ref
  ) {
    return (
      <span
        ref={ref}
        {...props}
        data-testid={props['data-testid'] ?? `google-font-icon-${name}`}
        className={clsx(
          'portal-icon',
          styles['root'],
          solid && styles['root--solid'],
          small && styles['root--small'],
          className
        )}
        title={title}
      >
        {name}
      </span>
    );
  }
);

export { GoogleFontIcon };
